import { Text, TextColor, type TextProps, TextSize } from '@vizit/atoms';

function DialogSubtitle(props: TextProps) {
  const { className, ...other } = props;

  return (
    <Text
      showEllipsis={false}
      size={TextSize.Sm}
      color={TextColor.Tertiary}
      className={className}
      slot="title"
      {...other}
    />
  );
}

export { DialogSubtitle };
